// src/admin/components/RunFilters.jsx
import React from 'react';
import FilterChipGroup from './FilterChipGroup.jsx';
import DateRangePicker from './DateRangePicker.jsx';
import Disclosure from './Disclosure.jsx';

const STATUS_OPTIONS = [
  { value: 'completed', label: 'Completed' },
  { value: 'approved',  label: 'Approved' },
  { value: 'failed',    label: 'Failed' },
  { value: 'drafting',  label: 'Drafting' },
  { value: 'reviewing', label: 'Reviewing' },
];

const PLATFORM_OPTIONS = [
  { value: 'linkedin',  label: 'LinkedIn' },
  { value: 'blog',      label: 'Blog' },
  { value: 'email',     label: 'Email' },
  { value: 'landing',   label: 'Landing' },
  { value: 'ads',       label: 'Ads' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook',  label: 'Facebook' },
];

const FORMAT_OPTIONS = [
  { value: 'post',          label: 'Post' },
  { value: 'carousel',      label: 'Carousel' },
  { value: 'seo',           label: 'SEO Article' },
  { value: 'newsletter',    label: 'Newsletter' },
  { value: 'case-study',    label: 'Case Study' },
  { value: 'email-classic', label: 'Email classic' },
];

const labelStyle  = { fontSize: '12px', color: '#6c6c6d', marginBottom: '6px' };
const selectStyle = { padding: '6px 10px', borderRadius: '6px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '13px', fontFamily: "'DM Sans', sans-serif" };
const inputStyle  = { padding: '6px 10px', borderRadius: '6px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '13px', fontFamily: "'DM Sans', sans-serif", minWidth: '220px' };

export default function RunFilters({
  status = [], since = '', before = '',
  user = '', platform = '', contentFormat = '',
  onChange,
}) {
  return (
    <>
      <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'flex-end', gap: '24px', flexWrap: 'wrap' }}>
        <div>
          <div style={labelStyle}>Stato</div>
          <FilterChipGroup
            options={STATUS_OPTIONS}
            value={status}
            onChange={(next) => onChange({ status: next.join(',') })}
          />
        </div>
        <div>
          <div style={labelStyle}>Periodo</div>
          <DateRangePicker since={since} before={before} onChange={(patch) => onChange(patch)} />
        </div>
      </div>

      <Disclosure title="Altri filtri">
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div>
            <div style={labelStyle}>User email</div>
            <input
              type="text" placeholder="user@example.com"
              value={user}
              onChange={e => onChange({ user: e.target.value })}
              style={inputStyle}
            />
          </div>
          <div>
            <div style={labelStyle}>Platform</div>
            <select value={platform} onChange={e => onChange({ platform: e.target.value })} style={selectStyle}>
              <option value="">Tutti</option>
              {PLATFORM_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
          </div>
          <div>
            <div style={labelStyle}>Content format</div>
            <select value={contentFormat} onChange={e => onChange({ content_format: e.target.value })} style={selectStyle}>
              <option value="">Tutti</option>
              {FORMAT_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
          </div>
        </div>
      </Disclosure>
    </>
  );
}
